module.exports = __webpack_public_path__ + "img/10.2d73cb9c.jpg";